<template>
  <v-row class="text-center" justify="space-around" height='90vh' style="margin: 0 0;">
    <v-col cols='12'>
      <v-row class="text-center" justify="space-around" height='90vh' style="margin: 0 0">
        <h2>Credits: {{credits}} ♦</h2>
      </v-row>
    </v-col>
    <v-col cols='12' v-if="level == 0">
      <p>
        You have been invited to participate in a clinical trial for RR-069a, a nanobot strain programmed for radical body reconstruction. Though originally developed for maimed veterans of the Antarctic War, ProteusCorp, an ambitious startup, is convinced that a modified version will be a hit for the civilian market.
      </p>
      </br>
      <p>
        RR-069a is programmed as a male-to-female body reconstructor. By default, ProteusCorp will select the experimental parameters on your behalf, but you are allowed to state your preferences, in exchange for one ♦ credit per choice.
      </p>
      </br>
      <p>
        Whenever you’re asked to roll d100, use a virtual dice roller to determine the number. You can always override the results with your preferred one in exchange for one ♦ credit per choice.
      </p>
      </br>
      <p>
        You start with five ♦♦♦♦♦ credits. You are allowed to dip into the negative during the game, but you must end the game with zero credits or higher.
      </p>
      </br>
      <v-btn text color='green' @click='level++'>Begin</v-btn>
      <!-- <p>
        Before you begin, choose a mode: Sandbox, Forgiving, Normal, or Strict.
      </p> -->
    </v-col>
    <v-col cols='12' v-if='level == 1'>
      <h3>Core Features</h3>
      <p>These are the core features of nanobot strain RR-069a, and cannot be opted out of.</p>
      </br>
      <v-btn text color='green' @click='level++'>Continue</v-btn>
      <v-row class="text-center" justify="space-around" height='90vh' style="margin: 0 0">
        <v-col cols='2' v-for='coreFeature in coreFeatures'>
          <v-hover v-slot:default="{ hover }">
          <v-card height='100%'>
            <v-card-subtitle>{{coreFeature.name}}</v-card-subtitle>
            <v-img
              :src="coreFeature.img"
              class="white--text align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              height="300px"
            >
              <v-expand-transition>
                <div
                  v-if="!hover"
                  class="d-flex transition-fast-in-fast-out darken-2 v-card--reveal subtitle-4 white--text"
                  style="height: 100%;"
                >
                  {{coreFeature.desc}}
                </div>
              </v-expand-transition>
            </v-img>
          </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols='12' v-if='level == 2'>
      <h3>Face</h3>
      <p>Two facial traits will be selected at random. You can select your own for one credit.</p>
      <div v-if='!faceRolled && !faceSelect'>
        <v-btn color='green' text @click="rollFaces">Roll</v-btn>
        <v-btn color='yellow' text @click="faceSelect = true && credits--">Select my Own</v-btn>
      </div>
      <div v-else>
        <v-btn color='green' text @click="selectedFaces.length == 2 ? level++ : twoFacesRequired = true">Continue</v-btn>
      </div>
      <v-row class="text-center" justify="space-around" height='90vh' style="margin: 0 0">
        <v-col cols='2' v-for='face in faces'>
          <v-hover v-slot:default="{ hover }">
            <v-card height='100%' :color='face.color' @click='faceSelect ? toggleFace(face) : ""'>
              <v-card-subtitle>{{face.name}}</v-card-subtitle>
              <v-img
                :src="face.img"
                class="white--text align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                height="300px"
              >
                <v-expand-transition>
                  <div
                    v-if="!hover"
                    class="d-flex transition-fast-in-fast-out darken-2 v-card--reveal subtitle-4 white--text"
                    style="height: 100%;"
                  >
                    {{face.desc}}
                  </div>
                </v-expand-transition>
              </v-img>
              <v-card-subtitle style='bottom: 0px;'>
                Incompatible with <span style="color: red;">{{face.incompatible}}</span>
              </v-card-subtitle>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
      <v-snackbar v-model="twoFaceLimit" timeout="2000">
        Limit is two facial trait choices
        <v-btn
          color="blue"
          text
          @click="twoFaceLimit = false"
        >
          Close
        </v-btn>
      </v-snackbar>
      <v-snackbar v-model="facesIncompatible" timeout="2000">
        Facial choices are not compatible
        <v-btn
          color="blue"
          text
          @click="facesIncompatible = false"
        >
          Close
        </v-btn>
      </v-snackbar>
      <v-snackbar v-model="twoFacesRequired" timeout="2000">
          Two facial choices are required
          <v-btn
            color="blue"
            text
            @click="twoFacesRequired = false"
          >
            Close
          </v-btn>
        </v-snackbar>
    </v-col>
    <v-col cols='12' v-if='level == 3'>
      <h3>Eyes</h3>
      <p>Eye color will be selected at random. You can select your own for one credit.</p>
      <div v-if='!eyeRolled && !eyeSelect'>
        <v-btn color='green' text @click="rollEye">Roll</v-btn>
        <v-btn color='yellow' text @click="eyeSelect = true && credits--">Select my Own</v-btn>
      </div>
      <div v-else>
        <v-btn color='green' text @click="selectedFaces.length == 2 ? level++ : twoFacesRequired = true">Continue</v-btn>
      </div>
      <v-row class="text-center" justify="space-around" height='90vh' style="margin: 0 0">
        <v-col cols='2' v-for='eye in eyes'>
          <v-card height='100%' :color='eye.color' @click='eyeSelect ? toggleEye(eye) : ""'>
            <v-card-subtitle>{{eye.name}}</v-card-subtitle>
            <v-img
              :src="eye.img"
              class="white--text align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              height="100px"
            >
            </v-img>
          </v-card>
        </v-col>
      </v-row>
      <v-snackbar v-model="eyesRequired" timeout="2000">
        Eye selection required
        <v-btn
          color="blue"
          text
          @click="eyesRequired = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'nanobotTrial',
    data: () => ({
      level: 0,
      credits: 5,
      faceRoll1: '',
      faceRoll2: '',
      coreFeatures: [
        {
          name: 'A Flower in Spring',
          img: "https://i.imgur.com/krm9Faj.png",
          desc: "The procedure gives you a feminine body shape and appearance. Your physiological age will be about 18-25 - a young adult in her physical prime."
        },
        {
          name: 'A Fresh Start',
          img: "https://i.imgur.com/bMXesER.png",
          desc: "An all-new you. Scars and imperfections fade away, piercings close up, tattoos are dissolved."
        },
        {
          name: 'Axolotl',
          img: "https://i.imgur.com/N0v6TCh.png",
          desc: "If you currently lack any limbs, fingers or other body parts, either through genetic defect or physical trauma, RR-069a will regrow them."
        },
        {
          name: 'Neurogenesis',
          img: "https://i.imgur.com/P38iy8V.png",
          desc: "Limited generation of new neurons make you about 10% more intelligent, as well as having positive effects on PTSD and other mental disorders."
        },
        {
          name: 'Telomere Rejuvenation',
          img: "https://i.imgur.com/ANluEdv.png",
          desc: "Essentially pauses the ageing process. Lasts up to a couple of decades before this procedure has to be refreshed."
        },
        {
          name: 'Immune',
          img: "https://i.imgur.com/bIaYhT7.png",
          desc: "Your immune system is augmented by nanites in your bloodstream, making you completely immune to most diseases, sexually-transmitted or otherwise."
        },
      ],
      faces: [
        {
          name: 'Impish',
          img: 'https://i.imgur.com/h10BPww.png',
          desc: "You have what could be described as an elfin face, with delicate features.",
          incompatible: 'Statuesque',
          color: 'white',
          minRoll: 1,
          maxRoll: 15
        },
        {
          name: 'Cute',
          img: 'https://i.imgur.com/aa2ps3V.png',
          desc: "You have an adorable, neotenous face, and people feel naturally protective of you. However they are also less likely to take you seriously.",
          incompatible: 'Sultry',
          color: 'white',
          minRoll: 16,
          maxRoll: 35
        },
        {
          name: 'Pretty',
          img: 'https://i.imgur.com/nSQmfaD.png',
          desc: "You have a conventionally pretty face that most people will find attractive.",
          incompatible: 'Exotic',
          color: 'white',
          minRoll: 36,
          maxRoll: 65
        },
        {
          name: 'Statuesque',
          img: 'https://i.imgur.com/iNclEVW.png',
          desc: "With your strong jawline and high cheekbones, your face would not be out of place in a classical museum.",
          incompatible: 'Impish',
          color: 'white',
          minRoll: 66,
          maxRoll: 75
        },
        {
          name: 'Sultry',
          img: 'https://i.imgur.com/Pv3jo6i.png',
          desc: "You have a naturally sensous face. Regardless of your actual disposition people attracted to your gender will be more likely to think of you in a sexual fashion.",
          incompatible: 'Cute',
          color: 'white',
          minRoll: 76,
          maxRoll: 95
        },
        {
          name: 'Exotic',
          img: 'https://i.imgur.com/lHY1if9.png',
          desc: "You are beautiful, but unconventionally so, whether by proportion or some unusual feauture. Wherever you go, your face will draw attention and turn heads.",
          incompatible: 'Pretty',
          color: 'white',
          minRoll: 96,
          maxRoll: 100
        },
      ],
      eyes: [
        {
          name: 'Brown',
          img: 'https://i.imgur.com/R87Ps5D.png',
          color: 'white',
          minRoll: 1,
          maxRoll: 67
        },
        {
          name: 'Hazel',
          img: 'https://i.imgur.com/2a68OJ8.png',
          color: 'white',
          minRoll: 68,
          maxRoll: 74
        },
        {
          name: 'Blue',
          img: 'https://i.imgur.com/lxD0al8.png',
          color: 'white',
          minRoll: 75,
          maxRoll: 86
        },
        {
          name: 'Amber',
          img: 'https://i.imgur.com/NnYmMmh.png',
          color: 'white',
          minRoll: 87,
          maxRoll: 93
        },
        {
          name: 'Green',
          img: 'https://i.imgur.com/JwQYgT1.png',
          color: 'white',
          minRoll: 94,
          maxRoll: 97
        },
        {
          name: 'Grey',
          img: 'https://i.imgur.com/6H86fHX.jpg',
          color: 'white',
          minRoll: 98,
          maxRoll: 100
        },
      ],
      selectedEyes: '',
      selectedFaces: [],
      twoFaceLimit: false,
      facesIncompatible: false,
      twoFacesRequired: false,
      faceRolled: false,
      faceSelect: false,
      eyeRolled: false,
      eyeSelect: false,
      eyesRequired: false,
    }),
    computed: {

    },
    methods:{
      toggleFace(face){
        if(this.selectedFaces.length == 2 && !this.selectedFaces.find(x => x.name == face.name)){
          this.twoFaceLimit = true;
        } else if(this.selectedFaces.find(x => x.name == face.name)){
          this.faces.find(x => x.name == face.name).color = 'white';
          if(this.selectedFaces.length == 2){
            if(this.selectedFaces[1].name == face.name){
              this.selectedFaces.splice(1, 1);
            } else {
              this.selectedFaces.splice(0, 1);
            }
          } else {
            console.log('Selected Faces length is one')
            this.selectedFaces = [];

          }
          console.log(this.selectedFaces);
        } else if(this.selectedFaces.length < 2){
          if(this.selectedFaces.find(x => x.incompatible == face.name)){
            this.facesIncompatible = true;
          } else {
            this.selectedFaces.push(face);
            this.faces.find(x => x.name == face.name).color = 'green';
          }
        }
      },
      rollFaces(){
        let roll1 = Math.floor(Math.random() * 100) + 1;
        this.selectedFaces.push(this.faces.find(face => face.minRoll <= roll1 && face.maxRoll >= roll1));
        while(this.selectedFaces.length == 1){
          let roll2 = Math.floor(Math.random() * 100) + 1;
          let face2 = this.faces.find(face => face.minRoll <= roll2 && face.maxRoll >= roll2);
          if(this.selectedFaces[0] != face2 && this.selectedFaces[0].incompatible != face2.name){
            this.selectedFaces.push(face2);
          }
          if(this.selectedFaces.length == 2){
            this.faces.find(face => face.name == this.selectedFaces[0].name).color = 'green';
            this.faces.find(face => face.name == this.selectedFaces[1].name).color = 'green';
          }
        }
        this.faceRolled = true;
      },
      toggleEye(eye){
        if(this.selectedEyes.name){
          this.eyes.find(x => x.name == this.selectedEyes.name).color = 'white';
        }
        this.selectedEyes = eye;
        this.eyes.find(x => x.name == eye.name).color = 'green';
      },
      rollEye(){
        let roll1 = Math.floor(Math.random() * 100) + 1;
        this.selectedEyes = this.eyes.find(eye => eye.minRoll <= roll1 && eye.maxRoll >= roll1);
        this.eyes.find(eye => eye.minRoll <= roll1 && eye.maxRoll >= roll1).color = 'green';
        this.eyeRolled = true;
      },
    }
  }
</script>

<style scoped>
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .7;
    position: absolute;
    width: 100%;
    background-color: black;
  }
</style>